var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.9,31.8l-0.1-0.2c-0.7-1.3-2.1-4.3-5.5-5.8c1.1-1.2,1.8-2.9,1.8-4.7c0-3.7-2.9-6.8-6.5-6.8s-6.5,3-6.5,6.8 c0,1.8,0.7,3.5,1.8,4.7c-3.3,1.3-4.7,4.1-5.5,6.6l-1.1,3.1l2.8,1l1.1-3.1C12.4,30,14,28,18.9,28c4.8,0,6.4,3.3,7.2,5l1.6,3.7 l2.8-1.2L28.9,31.8z M18.6,17.3c1.9,0,3.5,1.7,3.5,3.8s-1.6,3.8-3.5,3.8c-1.9,0-3.5-1.7-3.5-3.8S16.7,17.3,18.6,17.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuUser);
export default __webpack_public_path__ + "static/media/icon-menu-user.15bc068f5b8742b8427ca8e1b30b0f78.svg";
export { ForwardRef as ReactComponent };